import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

// Same fixed-tenant convention as useTenantModules.ts -- this DMS
// instance is single-tenant today.
const DEFAULT_TENANT_ID = '1225f4cb-43ae-463d-a6b0-53f721362dbf';

/** Whether this tenant's account is currently payment-restricted (a
 *  Stripe invoice failed and hasn't been paid since) -- see
 *  stripe-webhook and AppLayout's PaymentRequiredScreen gate. Fails
 *  open (false) while loading or on error, same reasoning as
 *  useTenantModules: a slow network shouldn't lock a paying tenant out
 *  of their own data. */
export function useTenantPaymentStatus() {
  const [paymentRestricted, setPaymentRestricted] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase
        .from('tenants')
        .select('payment_restricted')
        .eq('id', DEFAULT_TENANT_ID)
        .maybeSingle();
      if (cancelled) return;
      if (!error && data) setPaymentRestricted(!!data.payment_restricted);
      setLoaded(true);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { paymentRestricted, loaded };
}
